import { date, money, RfqStatus } from "@lumberset/takeoff-ui";
import { Button, Container, EmptyState, SectionHeader, Table } from "@lumberset/ui";
import { Envelope, Plus } from "@medusajs/icons";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { Crumbs } from "../../../components/crumbs";
import { rfqsQuery } from "../../../lib/queries";
import { recipientsSummary } from "../../../lib/rfq";

export const Route = createFileRoute("/_app/rfqs/")({
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(rfqsQuery),
  component: Rfqs,
});

function Rfqs() {
  const navigate = useNavigate();
  const { data } = useSuspenseQuery(rfqsQuery);

  return (
    <>
      <Crumbs trail={[{ label: "RFQs" }]} />
      <Container className="divide-y p-0">
        <SectionHeader
          level="h1"
          title="RFQs"
          description="Every takeoff you have sent to yards for quotes, and what came back."
          actions={
            <Button asChild size="small">
              <Link to="/rfqs/new" search={{}}>
                <Plus /> New RFQ
              </Link>
            </Button>
          }
        />
        {data.rfqs.length === 0 ? (
          <EmptyState
            icon={<Envelope />}
            title="No RFQs yet"
            description="An RFQ sends a finished takeoff to the yards you choose. Each gets a link to the material list, and their quotes line up here side by side."
            action={
              <Button asChild variant="secondary">
                <Link to="/projects" search={{}}>
                  Choose a project
                </Link>
              </Button>
            }
          />
        ) : (
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Project</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell className="max-lg:hidden">Sent</Table.HeaderCell>
                <Table.HeaderCell className="max-md:hidden">Yards</Table.HeaderCell>
                <Table.HeaderCell className="text-right">Lowest reply</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {data.rfqs.map((rfq) => (
                <Table.Row
                  key={rfq.id}
                  data-clickable="true"
                  onClick={() => navigate({ to: "/rfqs/$id", params: { id: rfq.id } })}
                >
                  <Table.Cell>
                    <div className="txt-compact-small-plus max-w-[40vw] truncate text-ui-fg-base">
                      {rfq.projectName}
                    </div>
                    <div className="txt-compact-xsmall text-ui-fg-muted md:hidden">
                      {recipientsSummary(rfq.recipients)}
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <RfqStatus status={rfq.status} />
                  </Table.Cell>
                  <Table.Cell className="max-lg:hidden">{date(rfq.sentAt)}</Table.Cell>
                  <Table.Cell className="max-md:hidden">
                    {recipientsSummary(rfq.recipients)}
                  </Table.Cell>
                  <Table.Cell className="tabular whitespace-nowrap text-right text-ui-fg-base">
                    {rfq.lowestTotalCents !== null ? money(rfq.lowestTotalCents) : "-"}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        )}
      </Container>
    </>
  );
}
